import { render, staticRenderFns } from "./return-from-vendor.vue?vue&type=template&id=2b9a0790&"
import script from "./return-from-vendor.vue?vue&type=script&lang=js&"
export * from "./return-from-vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports